import { getFromLocalStorage, setInLocalStorage } from 'Client/local-storage-api';
import { BE_TRACKING } from 'Tracking/constants';
export const ONE_HOUR_IN_MS = 3600000;
export function set(object: {}, date?: number) {
  setInLocalStorage(BE_TRACKING, object, {
    ttl: ONE_HOUR_IN_MS,
    date,
  });
}
export function get(trackingKey: string, date?: number) {
  return getFromLocalStorage(trackingKey, date) || {};
}
